
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "9cc2dfbc-ddf0-4d8e-b265-7c847999062b"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "C:/wamp64/www/dev/denet_parallel/pagina_WEB_Primavera/nuxt/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
